import React, { useState } from "react";

//Order Process Pages
import NumberDetails from "./NumberDetails";
import SelectProduct from "./SelectProduct";
import DetailsProduct from "./DetailsProduct";
import AddOrderDetailsForm from "./AddOrderDetailsForm";
import SubmitOrder from "./SubmitOrder";

// Local Libraries
import phrasebookLoad from "../../../../i18n";
import { gisRoutes } from "../../../../routes/routes";
import { initialState, submitValues } from "../orderInput";


import * as token from "../../../../helpers/token";
import { accountTypesConstants } from "../../../../constants";

//Redux
import {
  serviceNumberTypeActions,
  customerActions,
  alertActions,
  orderActions
} from "actions";

//Components
import { NewBreadcrumbs } from "../../../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { ProgressTab } from "../../../../components/SkyFramework/ProgressTab/ProgressTab";
import { connect } from "react-redux";

// Constants
const phrasebook = phrasebookLoad();

class OrderAdd extends React.Component {
  constructor(props) {
    super(props);

    this.state = initialState(token.loggedProperty('customer_id'));
    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.prevDefault = this.prevDefault.bind(this);

    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(serviceNumberTypeActions.getAllCoverage({ expired: false }));
    if (!this.state.customer_id) this.props.dispatch(customerActions.getAll(0, this.state.page));
    else this.props.dispatch(customerActions.get(this.state.customer_id));

  }

  componentDidUpdate(prevProps) {

    if (this.props.jurisdictions && prevProps && prevProps.jurisdictions !== this.props.jurisdictions) this.setState({ jurisdiction_coverage: this.props.jurisdictions });

    if (this.props.servicenumbertypes && prevProps && prevProps.servicenumbertypes !== this.props.servicenumbertypes)
      this.setState({ servicenumbertypes: this.props.servicenumbertypes });

    if (this.props.cities && prevProps && prevProps.cities !== this.props.cities)
      this.setState({ cities: this.props.cities });

    if (this.props.customers && prevProps && prevProps.customers !== this.props.customers) {
      this.setState({ customers: this.props.customers });
    }
    if (this.props.customer && prevProps && prevProps.customer !== this.props.customer) {
      this.setState({ customer: this.props.customer });
      this.setState({ reference: `${this.props.customer.name}-${Math.floor((Math.random() * 1000000) + 1)}` })
    }

  }

  // Proceed to next step
  nextStep = (e) => {
    e.preventDefault();
    const { step } = this.state;

    if (step === 1) {
      if (!this.state.customer_id || !this.state.service_type || !this.state.jurisdiction) {
        if (!this.state.customer_id) alertActions.error(phrasebook.validations.no_customer_selected);
        if (!this.state.service_type) alertActions.error(phrasebook.validations.no_service_type_selected);
        if (!this.state.jurisdiction) alertActions.error(phrasebook.validations.no_jurisdiction_selected);
      }
      else {
        this.setState({ numberSearched: true });

        const filters = {
          service_type: this.state.service_type,
          jurisdiction: this.state.jurisdiction,
          city: this.state.city,
          orderby: 'vendor_option',
          asc: true,
          expired: false
        };

        this.setState({ filtersNumbers: filters });

        this.props.dispatch(
          serviceNumberTypeActions.getAll(this.state.limit, this.state.page, filters)
        );

        this.setState({
          step: step + 1,
        });
      }
    } else if (step === 2) {
      const { value } = e.target;
      const { step } = this.state;
      this.setState({
        service_number_type_id: this.state.servicenumbertypes.data[value].id,
        selectedTypeNumber: this.state.servicenumbertypes.data[value],
        step: step + 1,
      });
    } else if (step === 4) {
      if (this.state.service_type === 'SIP Trunking') {
        if (([0, undefined, '0', ''].includes(this.state.number_quantity) && [0, undefined, '0', ''].includes(this.state.channel_quantity)) || !this.state.reference) {
          if ([0, undefined, '0', ''].includes(this.state.number_quantity) && [0, undefined, '0', ''].includes(this.state.channel_quantity)) alertActions.error(phrasebook.validations.no_quantity);
          if (!this.state.reference) alertActions.error(phrasebook.validations.no_reference);
        } else if (![0, undefined, '0', ''].includes(this.state.channel_quantity) && (this.state.channel_quantity % 5 != 0)) {
          alertActions.error(phrasebook.validations.not_multiple_five);
        }
        else this.setState({ step: step + 1 });
      } else {
        if ([0, undefined, '0', ''].includes(this.state.number_quantity) || !this.state.reference) {
          if ([0, undefined, '0', ''].includes(this.state.number_quantity)) alertActions.error(phrasebook.validations.no_number_quantity);
          if (!this.state.reference) alertActions.error(phrasebook.validations.no_reference);
        } else this.setState({ step: step + 1 });
      }



    } else {
      this.setState({
        step: step + 1,
      });
    }
  };

  // Go back to prev step
  prevStep = (e) => {
    e.preventDefault();
    const { step } = this.state;
    if (step === 4) {
      if (['SIP Trunking', 'DID'].includes(this.state.service_type)) this.setState({ translation_number_type: '1to1' })
      else this.setState({ translation_number_type: '1tomany' })
      this.setState({
        translation_number_type: undefined,
        translation_number_format: 'e.164',
        translation_number_prefix: undefined,
        translation_number_to: undefined,
        translation_number_to_file: undefined,
        step: step - 1,
      });
    }
    else if (step === 3) {
      this.setState({
        selectedTypeNumber: undefined,
        step: step - 1,
      });
    } else if (step === 2) {
      this.setState({
        service_number_type_id: undefined,
        selectedTypeNumber: undefined,
        servicenumbertypes: undefined,
        step: step - 1,
      });
    } else {
      this.setState({
        step: step - 1,
      });
    }

  };

  handleSubmit(e) {
    e.preventDefault();
    if (!this.state.terms_and_conditions) alertActions.error('Please accept Terms & Conditions before submitting your order');
    else {
      var newValues = submitValues(this.state);
      this.props.dispatch(orderActions.add(newValues));
    }
  }

  prevDefault(e) {
    e.preventDefault();
  }

  handleChange = (e) => {
    const { id, name, value, checked, type } = e.target;
    if (type === 'checkbox') {
      this.setState({ [id]: checked });
      if (id === 'translation_number_required') {
        if (checked) {
          if (['SIP Trunking', 'DID'].includes(this.state.service_type)) this.setState({ translation_number_type: '1to1' })
          else this.setState({ translation_number_type: '1tomany' })
          this.setState({ translation_number_required: checked })
        }
        else this.setState({
          translation_number_type: undefined,
          translation_number_format: 'e.164',
          translation_number_prefix: undefined,
          translation_number_to: undefined,
          translation_number_to_file: undefined,
        })
      }
      if (id === 'add_custom') {
        if (checked) {
          var custom = {};
          Object.assign(custom, this.state.selectedTypeNumber.tariff);
          delete custom['id'];
          this.setState({ custom_tariff: custom })
        } else {
          this.setState({ custom_tariff: undefined })
        }
      }
    } else {
      if (id) {
        if (id === 'service_type') {
          this.setState({
            service_type: value,
            jurisdiction: undefined,
            cities: undefined,
            city: undefined,
            city_specific: undefined,
          });
          this.props.dispatch(serviceNumberTypeActions.getAllCoverage({ service_type: value, expired: false }));
        }
        else if (id === 'jurisdiction' && ['SIP Trunking', 'DID'].includes(this.state.service_type)) {
          this.props.dispatch(serviceNumberTypeActions.getAllCoverageCities({ jurisdiction: value }));
          this.setState({ jurisdiction: value });
        } else if (id === 'translation_number_format' && !['e.164prefix', 'e.164prefix+'].includes(value)) {
          this.setState({ translation_number_format: value, translation_number_prefix: undefined })

        } else if (id == 'customer_id') {
          const customer = this.props.customers.data.find(customer => customer.id === parseInt(value));
          this.setState({
            customer_id: value,
            customer: customer,
            reference: `${customer.name}-${Math.floor((Math.random() * 1000000) + 1)}`
          })
        } else if (id == 'number_quantity') {
          if (value == '') this.setState({ [id]: undefined })
          else this.setState({ [id]: value });
        } else if (id == 'channel_quantity') {
          if (value == '') this.setState({ [id]: undefined })
          else this.setState({ [id]: value });
        } else if (id.includes('custom_')) {
          var custom_tariff = this.state.custom_tariff;
          custom_tariff[name] = value;
          this.setState({ custom_tariff: custom_tariff })
        }
        else {
          this.setState({ [id]: value });
        }
      }
      else if (name) this.setState({ [name]: value });
    }

  };

  render() {
    const { ...props } = this.state;
    var tabs = [
      {
        step: 1,
        stepDescription: phrasebook.orders.search_services,
        stepConditions: this.state.step === 1 && this.state.jurisdiction_coverage,
        stepPage: <NumberDetails
          actualState={this.state}
          nextStep={this.nextStep}
          handleChange={this.handleChange}
          serviceTypes={this.state.service_types}
          jurisdictionCoverage={this.state.jurisdiction_coverage}
          citiesCoverage={this.state.cities}
          customers={this.state.customers}
        />,
        setState: {
          step: 1, service_number_type_id: undefined,
          selectedTypeNumber: undefined,
          servicenumbertypes: undefined,
          cities: undefined,
          city: undefined,
          city_specific: undefined,
        },
        label: phrasebook.numbers.number_type
      },
      {
        step: 2,
        stepDescription: phrasebook.orders.select_services,
        stepConditions: this.state.step === 2 && this.state.servicenumbertypes,
        stepPage: <SelectProduct
          nextStep={this.nextStep}
          prevStep={this.prevStep}
          serviceNumberTypes={this.state.servicenumbertypes}
        />,
        setState: {
          step: 2, service_number_type_id: undefined,
          selectedTypeNumber: undefined,
        }, label: phrasebook.headerlinks.selectproduct
      },
      {
        step: 3,
        stepDescription: phrasebook.orders.detail_services,
        stepConditions: this.state.step === 3 && this.state.servicenumbertypes,
        stepPage: <DetailsProduct
          nextStep={this.nextStep}
          prevStep={this.prevStep}
          selectedTypeNumber={this.state.selectedTypeNumber}
        />,
        setState: { step: 3 },
        label: phrasebook.orders.product_features
      },
      {
        step: 4,
        stepDescription: phrasebook.orders.detail_order,
        stepConditions: this.state.step === 4,
        stepPage: <AddOrderDetailsForm
          actualState={this.state}
          nextStep={this.nextStep}
          prevStep={this.prevStep}
          handleChange={this.handleChange}
          selectedTypeNumber={this.state.selectedTypeNumber}
          accountLogged={token.loggedAccountType()}
        />,
        setState: { step: 4 },
        label: phrasebook.orders.add_to_order
      },
      {
        step: 5,
        setState: undefined,
        stepDescription: phrasebook.orders.submit_order,
        stepConditions: this.state.step === 5,
        stepPage: <SubmitOrder actualState={this.state} handleSubmit={this.handleSubmit} handleChange={this.handleChange} prevStep={this.prevStep} loggedAccount={token.loggedAccountType()} handleTerms={this.prevDefault} />,
        label: phrasebook.common.confirmation
      }

    ]
    return (
      <>
        <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }, { link: gisRoutes.management.order.list, label: phrasebook.headerlinks.orders }]} current={`${phrasebook.common.add} ${phrasebook.headerlinks.order}`} />
        <ProgressTab
          title={phrasebook.orders.make_order}
          tabs={tabs}
          actualState={this}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  const { authentication, servicenumbertype, order, customer } = state;
  const { authUser } = authentication;
  return {
    authUser,
    // dialcodes: georesource.dialcodes,
    // cities: georesource.cities,
    servicenumbertypes: servicenumbertype.servicenumbertypes,
    jurisdictions: servicenumbertype.servicenumbertypecoverage,
    cities: servicenumbertype.servicenumbertypecoveragecities,
    orders: order.orders,
    customers: customer.customers,
    customer: customer.customer
  };
}

const ordering = connect(mapStateToProps)(OrderAdd);
export default ordering;
